const navigationService = {
  navigate: null,
}
export default navigationService
